export default __webpack_public_path__ + "static/media/pic105.862d2b56.jpg";